import { render, staticRenderFns } from "./fullDialogBol.vue?vue&type=template&id=7260f4e7&"
import script from "./fullDialogBol.vue?vue&type=script&lang=js&"
export * from "./fullDialogBol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports